
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_28655_3344)"}},[_c('path',{attrs:{"d":"M74.804 13.636c-.232.18-4.328 2.488-4.328 7.62 0 5.936 5.212 8.036 5.368 8.088-.024.128-.828 2.876-2.748 5.676-1.712 2.464-3.5 4.924-6.22 4.924-2.72 0-3.42-1.58-6.56-1.58-3.06 0-4.148 1.632-6.636 1.632-2.488 0-4.224-2.28-6.22-5.08-2.312-3.288-4.18-8.396-4.18-13.244 0-7.776 5.056-11.9 10.032-11.9 2.644 0 4.848 1.736 6.508 1.736 1.58 0 4.044-1.84 7.052-1.84 1.14 0 5.236.104 7.932 3.968zm-9.36-7.26C66.688 4.9 67.568 2.852 67.568.804A3.84 3.84 0 0067.492 0c-2.024.076-4.432 1.348-5.884 3.032-1.14 1.296-2.204 3.344-2.204 5.42 0 .312.052.624.076.724.128.024.336.052.544.052 1.816 0 4.1-1.216 5.42-2.852z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_28655_3344"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(43.28)","d":"M0 0h32.56v40H0z"}})])])])
          )
        }
      }
    